import { render, staticRenderFns } from "./oauthRedirect.vue?vue&type=template&id=2119716f"
import script from "./oauthRedirect.vue?vue&type=script&lang=js"
export * from "./oauthRedirect.vue?vue&type=script&lang=js"
import style0 from "./oauthRedirect.vue?vue&type=style&index=0&id=2119716f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports